exports.uuid = () => `${new Date().getTime()}.${new Date().getMilliseconds()}`